import TeambookTextForm from "../../../default_components/TeambookTextForm";
import { useTranslation } from "react-i18next";
import TeambookDialog from "../../../default_components/TeambookDialog";
import PropTypes from "prop-types";

export const EmailFinishChangingModal = ({
  tokenMenuOpen,
  closeEmailSwitchModal,
  newEmail,
  setCode,
  code,
  errorMessage,
  errorField,
  closeErrorMessage,
  finishEmailSwitchRequest,
}) => {
  const { t } = useTranslation();
  return (
    <TeambookDialog
      open={tokenMenuOpen}
      title={t("profile.email.finish_email_switch")}
      onClose={closeEmailSwitchModal}
      withCloseButton
      content={
        <>
          <p className="first-text">
            {t("profile.email.text_1")}
            <b className="first-bolder-text">{newEmail}</b>.
          </p>
          <p className="second-text">{t("profile.email.text_2")}</p>
          <TeambookTextForm
            fieldName={t("profile.email.code")}
            onChange={setCode}
            fieldValue={code}
            type={"text"}
            width={"43%"}
            errorField={errorField}
            errorMessage={errorMessage}
            closeErrorMessage={closeErrorMessage}
            field={"token"}
          />
        </>
      }
      actionButtons={[
        { text: t("submit"), onClick: finishEmailSwitchRequest },
      ]}
    />
  );
};

EmailFinishChangingModal.propTypes = {
  tokenMenuOpen: PropTypes.bool.isRequired,
  closeEmailSwitchModal: PropTypes.func.isRequired,
  newEmail: PropTypes.string.isRequired,
  setCode: PropTypes.func.isRequired,
  code: PropTypes.string.isRequired,
  errorMessage: PropTypes.string,
  errorField: PropTypes.string,
  closeErrorMessage: PropTypes.func.isRequired,
  finishEmailSwitchRequest: PropTypes.func.isRequired,
}
